<template>
  <div
    v-if="notifications.length"
    class="push-notifications"
  >
    <PushNotification
      v-for="notification in notifications"
      :key="notification.id"
      :item="notification"
      class="push-notifications__item"
    />
  </div>
</template>

<script>
import { store } from '@/store';
import PushNotification from 'Elements/Push/PushNotification';

export default {
  computed: {
    notifications() {
      const newNotifications = store.state.notifications?.newNotifications || [];
      const readed = store.state.notifications?.readed;
      const readedPush = store.state.notifications?.readedPush;
      if (newNotifications.length) {
        return newNotifications
          ?.filter(item => !readed.includes(item.id) && !readedPush.includes(item.id))
          ?.slice(-3);
      }
      return newNotifications;
    }
  },
  components: {
    PushNotification,
  }
};
</script>

<style lang="scss" scoped>
.push-notifications {
  position: absolute;
  bottom: 0;
  left: 92px;
  z-index: 99;

  &__item:not(:last-child) {
    margin-bottom: 10px;
  }
}
</style>
